<template>
  <a class="promo-card" :href="promo.linkUrl" aria-labelledby="promo-card__text">
    <oie-base-label
      v-if="promo.title"
      :text="promo.title"
      :is-type="promo.promoType"
      css-classes="promo-card__label"></oie-base-label>

    <img :src="promo.image" alt="" class="promo-card__image">

    <div class="promo-card__content">
      <span class="promo-card__type"></span>

      <span id="promo-card__text" :href="promo.url" class="promo-card__text">
        {{ promo.text }}
      </span>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    promo: {
      type: Object,
      required: true
    }
  }
}
</script>
